module.exports = __webpack_public_path__ + "static/media/inventory_sound.6f819a8c.mp3";